var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('select',{ref:"input"},_vm._l((_vm.languages),function(name,index){return _c('option',{key:index,domProps:{"value":index,"selected":_vm.data === index}},[_vm._v(" "+_vm._s(name)+" ")])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }